import { useEffect, useState } from 'react';
import type { Session } from '@supabase/supabase-js';
import { supabase } from '../../lib/supabase';
import { ADMIN_EMAILS } from '../../config';

/**
 * Client-side admin check (cosmetic — the server 403s non-admins regardless).
 * loading stays true until the session has been read once, so callers can
 * avoid redirecting before the session is known.
 */
export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    supabase.auth.getSession().then(({ data }) => {
      if (mounted) {
        setSession(data.session);
        setLoading(false);
      }
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, s) => {
      setSession(s);
    });
    return () => {
      mounted = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  const email = session?.user?.email?.toLowerCase() || '';
  return { isAdmin: !!email && ADMIN_EMAILS.includes(email), loading };
}
